var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2514 29.0389L36.2266 30.0578C36.2266 30.0578 33.7908 32.4798 27.142 25.8688C20.4933 19.2578 22.9291 16.8358 22.9291 16.8358L23.5744 16.1941C25.1642 14.6134 25.314 12.0756 23.927 10.2228L21.0898 6.43293C19.3731 4.13981 16.0559 3.83689 14.0883 5.79336L10.5567 9.30491C9.58101 10.275 8.92722 11.5326 9.0065 12.9276C9.20933 16.4966 10.8241 24.1755 19.8346 33.1348C29.3898 42.6358 38.3554 43.0133 42.0216 42.6716C43.1813 42.5635 44.1898 41.9728 45.0025 41.1648L48.1988 37.9867C50.3563 35.8414 49.748 32.1636 46.9875 30.663L42.6888 28.3262C40.8763 27.3408 38.668 27.6303 37.2514 29.0389Z",
    fill: "url(#paint0_linear_321_269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_269",
    x1: 10.8309,
    y1: 10.0279,
    x2: 53.7274,
    y2: 17.0968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.580c45db918ec71bd84dc0cdbb4c83d4.svg";
export { ForwardRef as ReactComponent };